import { render } from "./c_Footer.vue?vue&type=template&id=4e904cc9"
const script = {}

import "../css/style.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__